/* global axios */
import ApiClient from '../ApiClient';

// Teletel-owned write path for the required-attributes-on-resolve setting.
// The stock account update does not accept this settings key without the
// Enterprise overlay, so the settings UI talks to this endpoint instead.
class TeletelConversationRequiredAttributesAPI extends ApiClient {
  constructor() {
    super('conversation-required-attributes', { accountScoped: true });
  }

  baseUrl() {
    return `/teletel${super.baseUrl()}`;
  }

  show() {
    return axios.get(this.url);
  }

  update(keys) {
    return axios.patch(this.url, { conversation_required_attributes: keys });
  }
}

export default new TeletelConversationRequiredAttributesAPI();
